// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"2999356e","323":"8ae9ce3f","391":"6b3bac63","436":"a3c1dc41","453":"abd36b29","691":"2006adf3","747":"e5a46480"}[chunkId] + ".chunk.js";
};